/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();

const query = graphql`
  query ResellerSubscriptionsFetchQuery($vendorAccountId: UUID, $resellerAccountId: UUID, $searchTerm: String, $first: Int, $offset: Int) {
    getvendorresellersubscriptioncharges2(
      vendoraccountid: $vendorAccountId
      reselleraccountid: $resellerAccountId
      searchterm: $searchTerm
      first: $first
      offset: $offset
    ) {
      totalCount
      nodes {
        appName
        appSku
        appLogo
        customerAccountName
        customerFirstName
        customerLastName
        customerContactEmail
        customerAddress1
        customerAddress2
        customerCity
        customerState
        customerCountry
        customerPostalCode
        tmBcSum
        ttlTmBcSum
        tmRebateSum
        ttlTmRebateSum
        customerAppId
        customerAppStatus
        programId
        programName
        programDescription
      }
    }
  }
  `;


function fetch(searchTerm, pAccountId, vendorAccountId, first, offset) {
  const variables = {
    searchTerm: searchTerm,
    resellerAccountId: pAccountId,
    vendorAccountId: vendorAccountId,
    first: first,
    offset: offset
  }

  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };
